import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';


import PrivateRhRoute from '../components/rh/private_route'; //rota privada do adm
import HomeRHScreen from '../screens/loginrh'; //tela de login do RH
import AdmLoggedScreen from '../screens/rh/home'; // tela logada do RH

import PrivateFuncRoute from '../components/funcionarios/private_route'; //rota privada dos funcionarios
import HomeFuncScreen from '../screens/loginfunc'; //tela de login dos funcionarios
import FuncLoggedScreen from '../screens/funcionarios/home'; // tela logada dos funcionarios

//rotas de cargos
import CargosScreen from '../screens/rh/cargos'; //CRUD de cargos
import ListCargosScreen from '../screens/rh/cargos/listar'; //CRUD de cargos
import CadCargosScreen from '../screens/rh/cargos/cadastrar'; //CRUD de cargos
import EditCargosScreen from '../screens/rh/cargos/editar'; //CRUD de cargos
//fim rotas cargos

//rotas de funcionários
import FuncionariosRHScreen from '../screens/rh/funcionarios'; //CRUD de funcionários
import FuncionariosHolRHScreen from '../screens/rh/funcionarios/holerites'; //Holerites dos funcionários RH
import ListFuncionariosScreen from '../screens/rh/funcionarios/listar'; //CRUD de funcionarios
import CadFuncionariosScreen from '../screens/rh/funcionarios/cadastrar'; //CRUD de funcionarios
import ImportFuncionariosScreen from '../screens/rh/funcionarios/importar'; //Importar funcionários
import EditFuncionariosScreen from '../screens/rh/funcionarios/editar'; //CRUD de funcionarios
import EditSenhaFuncionariosScreen from '../screens/rh/funcionarios/senha'; //Troca senha de funcionarios
//fim rotas funcionários

//rotas de holerites
import HoleritesRHScreen from '../screens/rh/holerites'; //CRUD de holerites
import CadHoleritesScreen from '../screens/rh/holerites/cadastrar'; //CRUD de holerites
import EditHoleritesScreen from '../screens/rh/holerites/editar'; //CRUD de holerites
import DelHoleritesScreen from '../screens/rh/holerites/deletar'; //CRUD de holerites
//fim rotas holerites

//rotas de holerites dos funcionários
import HoleritesFuncScreen from '../screens/funcionarios/holerites'; // holerites dos funcionários
//fim rotas holerites dos funcionários

//rotas de funcionários do RH
import RHScreen from '../screens/rh/rh'; //CRUD de usuários do sistema
import ListRHScreen from '../screens/rh/rh/listar'; //CRUD de rh
import CadRHScreen from '../screens/rh/rh/cadastrar'; //CRUD de rh
import EditRHScreen from '../screens/rh/rh/editar'; //CRUD de rh
import EditSenhaRHScreen from '../screens/rh/rh/senha'; //Troca senha de RH
//fim rotas funcionários do RH


const Rotas = () => {
    return (
        <BrowserRouter basename='/holerite'>
            <Routes>
                <Route exact path="/" element={<HomeFuncScreen />} />
                <Route exact path="/login" element={<HomeRHScreen />} />

                {/*rotas FUNCIONÁRIOS*/}
                <Route exact path="/funcionarios" element={<PrivateFuncRoute />}>
                    <Route exact path="/funcionarios" element={<FuncLoggedScreen />} />
                    {/* rotas de holerites funcionários */}
                    <Route exact path="/funcionarios/holerites" element={<HoleritesFuncScreen />} />
                    {/* fim de rotas de holerites funcionários */}
                </Route>
                {/*fim rotas FUNCIONÁRIOS*/}
                
                {/*rotas RH*/}
                <Route exact path="/rh" element={<PrivateRhRoute />}>
                    <Route exact path="/rh" element={<AdmLoggedScreen />} />
                    {/* rotas de CRUD holerites */}
                    <Route exact path="/rh/holerites" element={<HoleritesRHScreen />} />
                    <Route exact path="/rh/holerites/cadastrar" element={<CadHoleritesScreen />} />
                    <Route exact path="/rh/holerites/editar" element={<EditHoleritesScreen />} />
                    <Route exact path="/rh/holerites/apagar" element={<DelHoleritesScreen />} />
                    {/* fim de CRUD*/}
                    {/* rotas de CRUD cargos */}
                    <Route exact path="/rh/cargos" element={<CargosScreen />} />
                    <Route exact path="/rh/cargos/listar" element={<ListCargosScreen />} />
                    <Route exact path="/rh/cargos/cadastrar" element={<CadCargosScreen />} />
                    <Route exact path="/rh/cargos/editar/:id" element={<EditCargosScreen />} />
                    {/* fim de CRUD*/}
                    {/* rotas de CRUD funcionarios */}
                    <Route exact path="/rh/funcionarios" element={<FuncionariosRHScreen />} />
                    <Route exact path="/rh/funcionarios/holerites/:id" element={<FuncionariosHolRHScreen />} />
                    <Route exact path="/rh/funcionarios/listar" element={<ListFuncionariosScreen />} />
                    <Route exact path="/rh/funcionarios/cadastrar" element={<CadFuncionariosScreen />} />
                    <Route exact path="/rh/funcionarios/importar" element={<ImportFuncionariosScreen />} />
                    <Route exact path="/rh/funcionarios/editar/:id" element={<EditFuncionariosScreen />} />
                    <Route exact path="/rh/funcionarios/senha/:id" element={<EditSenhaFuncionariosScreen />} />
                    {/* fim de CRUD*/}
                    {/* rotas de CRUD rh */}
                    <Route exact path="/rh/rh" element={<RHScreen />} />
                    <Route exact path="/rh/rh/listar" element={<ListRHScreen />} />
                    <Route exact path="/rh/rh/cadastrar" element={<CadRHScreen />} />
                    <Route exact path="/rh/rh/editar/:id" element={<EditRHScreen />} />
                    <Route exact path="/rh/rh/senha/:id" element={<EditSenhaRHScreen />} />
                    {/* fim de CRUD*/}
                </Route>
                {/*fim rotas RH*/}

            </Routes>
        </BrowserRouter>
    )
}

export default Rotas;